webpackJsonp([82010677449910],{

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(132);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 3: Add Mock User Data'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'re going to add some mock user data to finish our Tweet component.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'data.3' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add a Mock User'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Our Tweet is looking pretty good, but we\'re still missing some data for the user\'s nickname and avatar. If you look at the data for our ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet'
	      ),
	      ', you\'ll notice it includes a property called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'userId'
	      ),
	      ' that has a number for a value:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        id: 1,\n        userId: 1,\n        text: \'Nothing can beat science!\',\n        createdAt: \'2018-04-24T05:10:49.382Z\'\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This number represents the id of the user who created the tweet. If we take a look at the API endpoint for ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/users'
	      ),
	      ' (located at ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://localhost:1337/users', target: '_blank' },
	        'http://localhost:1337/users'
	      ),
	      ') we can see that a user resource looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      {\n        id: 1,\n        nickname: "lucca",\n        avatar: "https://cloud.githubusercontent.com/assets/2637399/19027072/a36f0c7a-88e1-11e6-931e-7f67fe01367b.png",\n        createdAt: "2016-10-25T04:24:46.207Z",\n        updatedAt: "2016-10-25T04:24:46.207Z"\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'So just like we did with the mock tweet, we\'re going to create a mock user, using the data structure above.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Open the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Tweet'
	      ),
	      ' component and add a propType for ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'user'
	      ),
	      '. Then add a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'getDefaultProps()'
	      ),
	      ' method and populate it with some mock user data like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        // src/components/Tweet.js\n        ...\n          propTypes: {\n            tweet: PropTypes.object.isRequired,\n            user: PropTypes.object.isRequired\n          },\n\n          getDefaultProps() {\n            return {\n              user: {\n                id: 1,\n                data: {\n                  id: 1,\n                  nickname: "lucca",\n                  avatar: "https://cloud.githubusercontent.com/assets/2637399/19027072/a36f0c7a-88e1-11e6-931e-7f67fe01367b.png"\n                }\n              }\n            };\n          },\n        ...\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        // src/components/Tweet.js\n        class Tweet extends React.Component {\n          ...\n        }\n\n        Tweet.propTypes = {\n          tweet: PropTypes.object.isRequired,\n          user: PropTypes.object.isRequired\n        };\n\n        Tweet.defaultProps = {\n          user: {\n            id: 1,\n            data: {\n              id: 1,\n              nickname: "lucca",\n              avatar: "https://cloud.githubusercontent.com/assets/2637399/19027072/a36f0c7a-88e1-11e6-931e-7f67fe01367b.png"\n            }\n          }\n        };\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        // src/components/Tweet.js\n        class Tweet extends React.Component {\n\n          static propTypes = {\n            tweet: PropTypes.object.isRequired,\n            user: PropTypes.object.isRequired\n          };\n\n          static defaultProps = {\n            user: {\n              id: 1,\n              data: {\n                id: 1,\n                nickname: "lucca",\n                avatar: "https://cloud.githubusercontent.com/assets/2637399/19027072/a36f0c7a-88e1-11e6-931e-7f67fe01367b.png"\n              }\n            }\n          };\n\n          ...\n        }\n        ' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next, locate the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method, and use our new ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'user'
	      ),
	      ' prop to populate the nickname and avatar properties:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      // src/components/Tweet.js\n      ...\n        render() {\n          const { tweet, user } = this.props;\n          const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n\n          return (\n            <li className="list-group-item tweet">\n              <div className="image-container">\n                <img\n                  className="img-circle avatar"\n                  src={user.data.avatar} />\n              </div>\n              <div className="content-container">\n                <h4 className="list-group-item-heading title">\n                  {user.data.nickname}\n                </h4>\n                <h4 className="list-group-item-heading timestamp">\n                  {\'- \' + timestamp}\n                </h4>\n                <p className="list-group-item-text text">\n                  {tweet.data.text}\n                </p>\n              </div>\n            </li>\n          );\n        }\n      ...\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Tweet.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import moment from \'moment\';\n\n        export default createReactClass({\n          displayName: \'Tweet\',\n\n          propTypes: {\n            tweet: PropTypes.object.isRequired,\n            user: PropTypes.object.isRequired\n          },\n\n          getDefaultProps() {\n            return {\n              user: {\n                id: 1,\n                data: {\n                  id: 1,\n                  nickname: "lucca",\n                  avatar: "https://cloud.githubusercontent.com/assets/2637399/19027072/a36f0c7a-88e1-11e6-931e-7f67fe01367b.png"\n                }\n              }\n            };\n          },\n\n          render() {\n            const { tweet, user } = this.props;\n            const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n\n            return (\n              <li className="list-group-item tweet">\n                <div className="image-container">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                </div>\n                <div className="content-container">\n                  <h4 className="list-group-item-heading title">\n                    {user.data.nickname}\n                  </h4>\n                  <h4 className="list-group-item-heading timestamp">\n                    {\'- \' + timestamp}\n                  </h4>\n                  <p className="list-group-item-text text">\n                    {tweet.data.text}\n                  </p>\n                </div>\n              </li>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import moment from \'moment\';\n\n        class Tweet extends React.Component {\n\n          render() {\n            const { tweet, user } = this.props;\n            const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n\n            return (\n              <li className="list-group-item tweet">\n                <div className="image-container">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                </div>\n                <div className="content-container">\n                  <h4 className="list-group-item-heading title">\n                    {user.data.nickname}\n                  </h4>\n                  <h4 className="list-group-item-heading timestamp">\n                    {\'- \' + timestamp}\n                  </h4>\n                  <p className="list-group-item-text text">\n                    {tweet.data.text}\n                  </p>\n                </div>\n              </li>\n            );\n          }\n\n        }\n\n        Tweet.propTypes = {\n          tweet: PropTypes.object.isRequired,\n          user: PropTypes.object.isRequired\n        };\n\n        Tweet.defaultProps = {\n          user: {\n            id: 1,\n            data: {\n              id: 1,\n              nickname: "lucca",\n              avatar: "https://cloud.githubusercontent.com/assets/2637399/19027072/a36f0c7a-88e1-11e6-931e-7f67fe01367b.png"\n            }\n          }\n        };\n\n        export default Tweet;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import moment from \'moment\';\n\n        class Tweet extends React.Component {\n\n          static propTypes = {\n            tweet: PropTypes.object.isRequired,\n            user: PropTypes.object.isRequired\n          };\n\n          static defaultProps = {\n            user: {\n              id: 1,\n              data: {\n                id: 1,\n                nickname: "lucca",\n                avatar: "https://cloud.githubusercontent.com/assets/2637399/19027072/a36f0c7a-88e1-11e6-931e-7f67fe01367b.png"\n              }\n            }\n          };\n\n          render() {\n            const { tweet, user } = this.props;\n            const timestamp = moment(tweet.data.createdAt).fromNow().split(\' ago\')[0];\n\n            return (\n              <li className="list-group-item tweet">\n                <div className="image-container">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                </div>\n                <div className="content-container">\n                  <h4 className="list-group-item-heading title">\n                    {user.data.nickname}\n                  </h4>\n                  <h4 className="list-group-item-heading timestamp">\n                    {\'- \' + timestamp}\n                  </h4>\n                  <p className="list-group-item-text text">\n                    {tweet.data.text}\n                  </p>\n                </div>\n              </li>\n            );\n          }\n\n        }\n\n        export default Tweet;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to learn how to communicate with APIs and ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../../fetching/overview/' },
	        'replace our mock data with real data'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-data-step-3-js-13d5e4310c8ce5e562b0.js